import { mobileLargeMax, mobileLargeMin, tabletMax } from '@propertypal/shared/src/constants/mediaQueries';
import ContactBgBlurred from '@propertypal/shared/src/resources/bg/pn-contact-blurred-bg.jpg';
import ContactAgent from '@propertypal/shared/src/resources/images/contact/pn-contact-agent-form.png';
import styled from 'styled-components';
import { Bold } from '../typography';

export const Container = styled.div`
  position: relative;
  width: 110%;
  display: flex;
  align-items: center;
  backdrop-filter: blur(1px);
  -webkit-backdrop-filter: blur(1px);
  justify-content: space-evenly;
  margin-left: -24px;
  margin-top: 65px;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url(${ContactBgBlurred.src}) no-repeat center;
    background-size: cover;
    z-index: -1;
  }

  @media screen and (min-width: 768px) {
    margin-left: -54px;
  }

  @media screen and (${tabletMax}) {
    &::before {
      transform: scale(1.3);
    }
    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(255, 255, 255, 0.3);
      z-index: -1;
    }
  }

  @media screen and (${mobileLargeMax}) {
    flex-direction: column;
    margin-left: -15px;
  }
`;

export const ContactAgentBox = styled.div`
  background: url(${ContactAgent.src}) no-repeat center;
  background-size: contain;
  height: 418px;
  min-width: 302px;
  align-self: flex-end;

  @media screen and (${tabletMax}) {
    width: 35%;
    min-width: 180px;
  }

  @media screen and (${mobileLargeMax}) {
    align-self: inherit;
    background-position: top;
    margin-top: 40px;
    height: 200px;
  }
`;

export const TextBox = styled.div`
  max-width: 465px;
  text-align: left;
  padding-left: 30px;
  padding-top: 20px;

  ${Bold} {
    color: ${({ theme }) => theme.textDark};
  }

  @media screen and (${tabletMax}) and (${mobileLargeMin}) {
    width: 40%;
    padding-top: 0;
    padding-left: 10px;
    min-width: 200px;
  }

  @media screen and (${mobileLargeMax}) {
    text-align: center;
    max-width: 330px;
    margin-top: 80px;
    padding-top: 0;
    padding-left: 0;
    padding: 0 15px;
  }
`;
